<template>
  <div class="set">
    <div class="photoDiv">
      <div class="photoTitle">头像</div>
      <div class="photoImgDiv">
        <img v-if="this.mine.url != null && this.mine.url != ''" :src="this.mine.url" alt="头像" class="photoImg" />
        <img v-else :src="defaultAvatar" alt="" class="photoImg"/>
      </div>
      <div class="moreIconDiv" @click="photoShow = true">
        <img
          src="../../assets/image/btn_gengduo_nor.png"
          alt="更多"
          class="moreIcon"
        />
      </div>
    </div>
    <div class="telDiv">
      <div class="telTitle">手机号码</div>
      <div class="moreIconDiv" @click="gotoAlterTel">
        <img
          src="../../assets/image/btn_gengduo_nor.png"
          alt="更多"
          class="moreIcon"
        />
      </div>
    </div>
    <div class="signOut">
      <button class="signOutBtn" @click="logout">退出登录</button>
    </div>
    <!-- <div class="copyright">技术 • 运营</div>
    <div class="copyrightCompany">辽宁校友汇数据科技有限公司</div> -->
    <van-action-sheet
      v-model="photoShow"
      @select="onSelect"
      description="更换头像"
      cancel-text="取消"
    >
      <van-uploader :before-read="beforeRead" :after-read="afterRead">
        <div class="selectPhoto">从相册选择</div>
      </van-uploader>
    </van-action-sheet>
  </div>
</template>
<script>
// import * as imageConversion from "image-conversion";
import defaultAvatar from '@/assets/image/defaultAvatar.png'
import Base64 from "@/utils/base64";

export default {
  data() {
    return {
      defaultAvatar,
      mine: "",
      photoShow: false,
      userId: window.localStorage.getItem("user_id"),
      // userId: "43995354",
      openid: window.localStorage.getItem("openid"),
    };
  },
  created() {
    this.getMine();
  },
  methods: {
    async getMine() {
      let base64 = new Base64()
      const userId = base64.encode(window.localStorage.getItem("user_id"))
      const result = await this.$http.get("/my/getBasic", {
        params: { userId: userId},
      });
      this.mine = result.data;
      window.localStorage.setItem("phone", result.data.phone);
      if (this.mine.url == "") {
        this.mine.url = require("../../assets/image/btn_touxiang_nor.png");
      }
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.photoShow = false;
      console.log(item.name);
    },
    // 返回布尔值
    // 先判断上传文件类型
    beforeRead(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$toast("请上传 jpg,png 格式图片");
        return false;
      }
      return true;
      /* return new Promise((resolve, reject) => {
        console.log("压缩前", file); // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会
        imageConversion.compressAccurately(file, 400).then((res) => {
          // console.log(res)
          res = new File([res], file.name, {
            type: res.type,
            lastModified: Date.now(),
          });
          console.log("压缩后", res);
          resolve(res);
        });
      }); */
    },
    /* onOversize(file) {
      console.log(file);
      this.$toast("文件大小不能超过 500kb");
    }, */
    async afterRead(file) {
      // 此时可以将文件上传至服务器
      console.log(file);
      let param = new window.FormData();
      let base64 = new Base64()
      param.append("file", file.file);
      param.append("userId", base64.encode(window.localStorage.getItem("user_id")));
      console.log("param", param);
      const result = await this.$http.post("/settings/updateUrl", param);
      if (result.data.msg == "上传成功") {
        this.$toast("修改成功");
        location.reload();
      } else {
        this.$toast(result.data.msg);
      }
    },
    gotoSet() {
      return this.$router.push("/set");
    },
    gotoAlterTel() {
      return this.$router.push("/alterTel");
    },

    logout() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否要退出登录？",
        })
        .then(() => {
          this.qrtc();
        })
        .catch(() => {
          // on cancel
        });
    },

    async qrtc() {
      const result = await this.$http({
        url: "/login/quitLogin",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({
          openid: this.openid,
        }),
      });
      if (result.data.code === "101") {
        this.$toast("退出成功");
        window.localStorage.removeItem("phone");
        window.localStorage.removeItem("token");
        return this.$router.push("/login");
      } else {
        this.$toast("请稍后重试");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.set {
  position: relative;
  height: 95%;

  .photoDiv {
    position: relative;
    left: 5%;
    width: 90%;
    margin-top: 20px;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;

    .photoTitle {
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
      font-size: 1rem;
      font-weight: bold;
      color: #333333;
    }

    .photoImgDiv {
      width: 20%;
      height: 18vw;
      position: relative;
      left: 65%;
      padding: 10px 0;
      // border: 1px solid #d45252;


      .photoImg {
        position: relative;
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        background-size: 100% 100%;
        // background-position: center;
        // background-repeat: no-repeat;
        // border: 1px solid #d45252;
      }
    }
  }

  .telDiv {
    position: relative;
    left: 5%;
    width: 90%;
    margin-top: 20px;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;
    height: 18vw;
    padding: 10px 0;

    .telTitle {
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
      font-size: 1rem;
      font-weight: bold;
      color: #333333;
    }
  }

  .signOut {
    position: absolute;
    top: 81%;
    left: 5%;
    width: 90%;

    .signOutBtn {
      border: 0;
      background: linear-gradient(270deg, #00706E, #00706E);
      color: white;
      width: 100%;
      border-radius: 30px;
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: bold;
    }
  }

  .copyright {
    position: absolute;
    top: 92%;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 400;
    color: #999999;
  }

  .copyrightCompany {
    position: absolute;
    top: 95%;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 400;
    color: #999999;
  }
}

.moreIconDiv {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  width: 2.5vw;
  max-width: 30px;

  .moreIcon {
    width: 100%;
  }
}

.selectPhoto {
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #00706E;
  margin: 20px 0;
}

.van-uploader {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/mine/MySet.vue